module.exports = __webpack_public_path__ + "img/btn_cancel3.e1cc1cbc.png";